import styled from 'styled-components';
import Colors from 'assets/Colors';

const Container = styled.div`
  width: 100%;
  background: ${Colors.background_secondary};
  border-radius: 6px;
  max-width: 100vw;
  //   box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
  margin-bottom: 38px;
`;

const TableContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 40px 20px;
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 21px;
  color: ${Colors.text_primary};
  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (min-width: 992px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media (min-width: 1200px) {
    grid-template-columns: repeat(6, 1fr);
  }
  @media (min-width: 1800px) {
    grid-template-columns: repeat(8, 1fr);
  }
`;

export default {
  Container,
  TableContainer,
};
